import { render, staticRenderFns } from "./ModalTermsAndCon.vue?vue&type=template&id=31ed75b3&scoped=true&"
import script from "./ModalTermsAndCon.vue?vue&type=script&lang=js&"
export * from "./ModalTermsAndCon.vue?vue&type=script&lang=js&"
import style0 from "./ModalTermsAndCon.vue?vue&type=style&index=0&id=31ed75b3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ed75b3",
  null
  
)

export default component.exports